// extracted by mini-css-extract-plugin
module.exports = {"btn":"RegisterDeviceWithOutlet_btn__JCt3d"};